import { GridColumn } from 'types/grid';

// 문의 유형 매핑
export const inquiryTypeMap: Record<string, string> = {
  USE: 'Use a ground station',
  SHARE: 'Share a ground station',
  ESTIMATE: 'Estimate Inquiry',
  PRESS: 'Make a press inquiry',
  OTHER: 'Other'
};

// 작성자 유형 매핑
export const writerTypeMap: Record<string, string> = {
  MEMBER: 'MEMBER',
  GUEST: 'GUEST'
};

// 상태 설정 함수
export const getStatusConfig = (status: string, isAnswered: boolean) => {
  if (isAnswered || status === 'COMPLETED') {
    return {
      text: 'COMPLETED',
      bgColor: 'bg-green-100',
      textColor: 'text-green-800',
      borderColor: 'border-green-200'
    };
  }
  
  // PENDING 상태
  return {
    text: 'PENDING',
    bgColor: 'bg-yellow-100',
    textColor: 'text-yellow-800',
    borderColor: 'border-yellow-200'
  };
};

// 그리드 컬럼 정의
export const inquiryGridColumns: GridColumn[] = [
  { key: 'inquiryId', title: 'ID', width: 60 },
  { key: 'inquiryType', title: 'Inquiry Type', width: 120 },
  { key: 'writerName', title: 'Author', width: 120 },
  { key: 'inquiryWriterType', title: 'Category', width: 100 },
  { key: 'writerEmail', title: 'Email', width: 180 },
  { key: 'createdDate', title: 'Registered At', width: 120 },
  { key: 'inquiryStatus', title: 'Status', width: 100 },
  { key: 'answeredDate', title: 'Reply date', width: 120 }
];
